module.exports = __webpack_public_path__ + "media/images/thumb/flags/16/SI-da31b5a89f314112d9ed0037a7782186.png";